/**
 * jp-cart.js — Helpers panier « Club Jagger Plus » (window.JPCart)
 * Partagé par la landing (jagger-plus-landing.js) et l'upsell drawer
 * (cart-club-upsell.js). Charge-once (guard).
 *
 * Le cart drawer du thème utilise un PORTAIL (xo-modal[xo-portal]) : toute
 * manipulation manuelle du DOM casse le rendu. On laisse donc le thème
 * re-render en (r)ouvrant le drawer via son trigger natif.
 */
(function () {
  'use strict';
  if (window.JPCart) return;

  var CLUB_HANDLE = 'club-jagger-plus';
  var TRIGGER_SEL = 'xo-modal-trigger[xo-name="cart"]';

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function isClubLine(item) {
    // Club-SPÉCIFIQUE (handle) : un abonnement complément ne doit PAS compter comme Club
    var h = item.handle || (item.url || '');
    return h.indexOf(CLUB_HANDLE) > -1;
  }

  function findClubSubLines(cart) {
    return (cart.items || []).filter(isClubLine).map(function (i) {
      return {
        key: i.key,
        variant_id: i.variant_id,
        selling_plan_id: i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.id
      };
    });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function addItem(variant, plan) {
    var item = { id: parseInt(variant, 10), quantity: 1 };
    if (plan) item.selling_plan = parseInt(plan, 10);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add HTTP ' + r.status);
      return r.json();
    });
  }

  // Garantit que le panier contient exactement le plan Club demandé.
  // Si un autre abo Club est déjà présent → on le retire (switch de plan).
  // Si le même plan est déjà là → no-op.
  function setClubPlan(variant, plan) {
    variant = String(variant);
    plan = plan ? String(plan) : '';
    return getCart().then(function (cart) {
      var subs = findClubSubLines(cart);
      var same = subs.some(function (s) {
        return String(s.variant_id) === variant && String(s.selling_plan_id || '') === plan;
      });
      if (same) return 'exists';
      var chain = Promise.resolve();
      subs.forEach(function (s) {
        chain = chain.then(function () { return changeLine(s.key, 0); });
      });
      return chain.then(function () { return addItem(variant, plan); }).then(function () { return 'added'; });
    });
  }

  function getTrigger() {
    var ts = Array.prototype.slice.call(document.querySelectorAll(TRIGGER_SEL));
    return ts.filter(function (t) { return t.offsetParent !== null; })[0] || ts[0];
  }

  // Drawer ouvert si le panneau #xo-cart-mini est à plus de moitié dans le viewport.
  function isDrawerOpen() {
    var m = document.querySelector('#xo-cart-mini');
    if (!m) return false;
    var r = m.getBoundingClientRect();
    return r.width > 0 && r.left < (window.innerWidth - r.width / 2);
  }

  var OPEN_FLAG = 'jpOpenCartDrawer';

  // Le cart drawer du thème utilise un portail + un cache interne du panier :
  // un swap DOM manuel casse le rendu, et un close/reopen sert du contenu
  // périmé. Le SEUL rendu fiable et frais (server-side) après une mutation
  // « externe » (nos /cart/add|change) est obtenu en rechargeant la page puis
  // en rouvrant le drawer (le 1er open après load re-fetch toujours).
  function refreshAndOpenDrawer() {
    try { sessionStorage.setItem(OPEN_FLAG, '1'); } catch (e) {}
    window.location.reload();
  }

  // Au chargement : si le flag est posé, on ouvre le drawer (contenu frais).
  function autoOpenIfFlagged() {
    var flagged;
    try { flagged = sessionStorage.getItem(OPEN_FLAG); } catch (e) {}
    if (!flagged) return;
    try { sessionStorage.removeItem(OPEN_FLAG); } catch (e) {}
    var tries = 0;
    var iv = window.setInterval(function () {
      var t = getTrigger();
      if (t && !isDrawerOpen()) { window.clearInterval(iv); t.click(); }
      else if (isDrawerOpen() || ++tries > 50) { window.clearInterval(iv); }
    }, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpenIfFlagged);
  } else {
    autoOpenIfFlagged();
  }

  // Rafraîchit le contenu du cart drawer EN PLACE (sans reload) via la Section
  // Rendering API : on re-render la section du panier et on morph chaque élément
  // [xo-unique-id] (contenu du drawer + compteur s'il est dans la section).
  // Fallback sur le reload si la structure est introuvable.
  function refreshDrawerInPlace() {
    var content = document.querySelector('[xo-unique-id="xo-cart-mini-content"]');
    var sec = content;
    while (sec && !(sec.classList && sec.classList.contains('shopify-section'))) sec = sec.parentElement;
    if (!content || !sec) { refreshAndOpenDrawer(); return Promise.resolve(); }
    var secId = sec.id.replace(/^shopify-section-/, '');
    return fetch('/?sections=' + encodeURIComponent(secId), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[secId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[xo-unique-id]').forEach(function (fresh) {
          var uid = fresh.getAttribute('xo-unique-id');
          var cur = document.querySelector('[xo-unique-id="' + uid + '"]');
          if (cur) cur.innerHTML = fresh.innerHTML;
        });
      })
      .catch(function () {});
  }

  window.JPCart = {
    getCart: getCart,
    findClubSubLines: findClubSubLines,
    setClubPlan: setClubPlan,
    isDrawerOpen: isDrawerOpen,
    refreshAndOpenDrawer: refreshAndOpenDrawer,
    refreshDrawerInPlace: refreshDrawerInPlace
  };
})();
